import Image from "next/image";

export default function AboutUs({ company }) {
    return (
        <>

            <section className="h3-about-section ptb-40">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="at-section-title text-center">
                                <span className="at-subtitle position-relative lead text-primary shape-primary">Escolha a {company.nickName}</span>
                                <h2 className="h1 mt-2 mb-4">Por que nos escolher?</h2>
                                <p className="fw-500 mb-0">Veículos de procedência, excelência no atendimento e preço justo são os pilares de nossa empresa e receita do nosso sucesso.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-4 g-4">
                        <div className="col-xl-4 col-lg-6">
                            <div className="h2-about-item-box bg-white rounded position-relative z-1">
                                <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-green">
                                    <Image src={'/img/icons/missao.svg'} alt="missão" width={40} height={40} />
                                </span>
                                <h4 className="mb-4 mt-20">Missão</h4>
                                <p className="mb-0" style={{ textAlign: 'center' }}>
                                    {
                                        company.mission
                                            ? company.mission.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                                return <span key={key}>{item}<br /></span>
                                            })
                                            : ''
                                    }
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <div className="h2-about-item-box bg-white rounded position-relative z-1">
                                <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary">
                                    <Image src={'/img/icons/visao.svg'} alt="visão" width={40} height={40} />
                                </span>
                                <h4 className="mb-4 mt-20">Visão</h4>
                                <p className="mb-0" style={{ textAlign: 'center' }}>
                                    {
                                        company.vision
                                            ? company.vision.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                                return <span key={key}>{item}<br /></span>
                                            })
                                            : ''
                                    }
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <div className="h2-about-item-box bg-white rounded position-relative z-1">
                                <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-blue">
                                    <Image src={'/img/icons/valores.svg'} alt="valores" width={40} height={40} />
                                </span>
                                <h4 className="mb-4 mt-20">Valores</h4>
                                <p className="mb-0" style={{ textAlign: 'center' }}>
                                    {
                                        company.values
                                            ? company.values.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                                return <span key={key}>{item}<br /></span>
                                            })
                                            : ''
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="h3-progress pb-120">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-7">
                            <div className="h3-progress-left position-relative pe-0 pe-lg-4" style={{ height: '100%', width: '100%' }}>
                                <Image
                                    src={'/img/store.jpg'}
                                    alt={company.nickName}
                                    width={1024}
                                    height={683}
                                    sizes="100vw"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                    }} />
                            </div>
                        </div>
                        <div className="col-xl-5">
                            <div className="h3-progress-right mt-50 mt-xl-0">
                                <div className="at-section-title">
                                    <span className="at-subtitle lead text-secondary shape-primary position-relative">Sobre a <mark className="bg-transparent text-primary p-0">{company.nickName}</mark></span>
                                    <h2 className="h1 mt-3 mb-3">Nossa prioridade é você!</h2>
                                    <p style={{ textAlign: 'justify' }}>
                                        {
                                            company.about
                                                ? company.about.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                                    return <span key={key}>{item}<br /></span>
                                                })
                                                : ''
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}